import { Button, InputGroup } from '@/common'
import useI18n from '@/shared/hooks/usei18n'
import { SupplierFormData, supplierContactSchema } from '../SupplierForm.schema'
import z from 'zod'
import { useState } from 'react'
import EmailInputGroup from '@/shared/components/EmailInputGroup'

type StateSchema = z.infer<typeof supplierContactSchema>

type Props = {
  data: SupplierFormData
  onNextClick: (data: StateSchema) => void
  onBackClick: () => void
}

export default function SupplierContactDetailsStep({ data, onNextClick, onBackClick }: Props) {
  const { t } = useI18n()

  const [state, setState] = useState<StateSchema>({
    contactName: data.contactName,
    contactPhoneNumber: data.contactPhoneNumber,
    contactEmail: data.contactEmail
  })

  const { contactName, contactPhoneNumber, contactEmail } = state
  const validation = supplierContactSchema.safeParse(state)

  const handleInputChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    setState({ ...state, [evt.target.id]: evt.target.value })
  }

  const handleNext = () => {
    onNextClick(state)
  }

  return (
    <div className="space-y-6 pb-2">
      <h2 className="text-xl font-semibold mb-2">
        {t('suppliers:supplierInputFields.sections.contactDetails')}
      </h2>
      <p className="text-sm text-text-secondary mb-6">
        {t('suppliers:createSupplierDialog.steps.descriptions.contactDetails')}
      </p>
      <div className="space-y-4">
        <div className="grid sm:grid-cols-2 gap-4">
          <InputGroup
            id="contactName"
            label={t('suppliers:supplierInputFields.contactName')}
            value={contactName}
            required
            onChange={handleInputChange}
          />
          <InputGroup
            id="contactPhoneNumber"
            label={t('suppliers:supplierInputFields.contactPhoneNumber')}
            value={contactPhoneNumber}
            required
            onChange={handleInputChange}
          />
        </div>
        <EmailInputGroup
          id="contactEmail"
          label={t('suppliers:supplierInputFields.contactEmail')}
          value={contactEmail}
          required
          onChange={handleInputChange}
        />
      </div>
      <div className="flex justify-between pt-16">
        <Button variant="neutral" onClick={onBackClick}>
          {t('common:actions.back')}
        </Button>
        <Button onClick={handleNext} disabled={!validation.success}>
          {t('common:actions.next')}
        </Button>
      </div>
    </div>
  )
}
